(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!document.documentElement.dataset.synxProductDescriptionBound) {
    document.documentElement.dataset.synxProductDescriptionBound = 'true';
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#section-info"]');
      if (!link) return;
      const accordions = Array.from(document.querySelectorAll('[data-product-description-accordion]'));
      const accordion = accordions.find((item) => item.offsetParent !== null) || accordions[0];
      if (!accordion) return;
      event.preventDefault();
      accordion.open = true;
      accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
